/* eslint-disable css-modules/no-unused-class  */
import { useEffect, useState, FC } from 'react';
import { useSelector } from 'react-redux';
import { FullPageLoader } from 'learning-panel-components';
import { selectRole, selectUserUuid } from '@redux/slices/userSlice';
import { useGetPrimaryCourseMetadata } from '@queries/platform/userContent';
import PrimaryCourse from './primaryCourse';

const PrimaryCourseContainer: FC<{ setIsPrimaryCourseDialogOpen: Function }> = ({
    setIsPrimaryCourseDialogOpen
}: {
    setIsPrimaryCourseDialogOpen: Function;
}) => {
    const userUuid = useSelector(selectUserUuid);
    const role = useSelector(selectRole);
    const isAdmin = role === 'admin' || role === 'superAdmin';
    const [primaryCourse, setPrimaryCourse] = useState<any>(null);
    const [hasNoPrimaryCourse, setHasNoPrimaryCourse] = useState<boolean>(false);

    const { data: primaryCourseData, isLoading, isError } = useGetPrimaryCourseMetadata(userUuid);

    useEffect(() => {
        if (!primaryCourseData?.data) return;
        if (Object.keys(primaryCourseData.data).length === 0) {
            setHasNoPrimaryCourse(true);
            // Admins/super admins have no primary course by design: don't force the
            // blocking "select primary course" dialog on them. Regular users still get it.
            if (!isAdmin) setIsPrimaryCourseDialogOpen(true);
            return;
        }
        setHasNoPrimaryCourse(false);
        const course = primaryCourseData.data;
        const primaryCourseTmp = {
            uuid: course.uuid,
            displayName: course.display_name,
            completionPercentage: course.completion_percentage,
            score: course.score,
            iconUrl: course.icon_url ?? `${process.env.PUBLIC_URL}/images/courseDefaultCard.svg`,
            totalLessons: course.total_lessons,
            completedLessons: course.completed_lessons
        };
        setPrimaryCourse(primaryCourseTmp);
    }, [primaryCourseData]);

    if (isLoading || (primaryCourse === null && !hasNoPrimaryCourse && !isError)) {
        return <FullPageLoader />;
    }

    if (hasNoPrimaryCourse || isError) {
        // No primary course, or the metadata request failed: render nothing instead of
        // spinning the loader forever. Regular users with no course are prompted by the
        // parent's selection dialog; admins are not.
        return null;
    }

    return (
        <PrimaryCourse
            isLoading={isLoading}
            score={primaryCourse?.score}
            completionPercentage={primaryCourse?.completionPercentage}
            totalLessons={primaryCourse?.totalLessons}
            competedLessons={primaryCourse?.completedLessons}
        ></PrimaryCourse>
    );
};

export default PrimaryCourseContainer;
